<template>
    <div class="footer">
        <p class="footer-title">
            © Pvh24.ru, 2019
        </p>
    </div>
</template>

<script>
export default {
    name: 'Footer'
};
</script>
